<p-card *ngIf="!isLoggedIn" [style]="{'margin': '0 auto'}">
  <div class="p-field p-grid">
    <label for="username" class="p-col-fixed" style="width:100px">Username</label>
    <div class="p-col">
      <input id="username" [(ngModel)]="userName" type="text" pInputText autocomplete="off">
    </div>
  </div>
  <div class="p-field p-grid">
    <label for="password" class="p-col-fixed" style="width:100px">Password</label>
    <div class="p-col">
      <input id="password" [(ngModel)]="userPassword" type="password" autocomplete="off" pInputText>
    </div>
  </div>
  <button pButton type="button" label="Login" (click)="login()" [disabled]="!userName || !userPassword"></button>
</p-card>
<p-dataView *ngIf="isLoggedIn" (onLazyLoad)="loadData($event)" paginatorPosition="both" [paginator]="true" [lazy]="true"
            [value]="records" [rows]="queryParam.rows" layout="grid" [loading]="loading" [totalRecords]="totalRecords">
  <p-header>
    <div class="p-col-12 p-md-6">
      <p-dropdown [options]="providers" [(ngModel)]="selectedProvider" [style]="{'min-width':'15em', 'float': 'left'}"
                  (onChange)="loadData(null, true)"></p-dropdown>
      <div class="ui-inputgroup ui-helper-clearfix p-sm-offset-1">
        <input type="text" pInputText placeholder="Keyword" [(ngModel)]="queryParam.search">
        <button pButton type="button" label="Search" (click)="loadData(null, true)"></button>
      </div>
      <div>
        <pre>{{ apiUrl }}</pre>
      </div>
    </div>
  </p-header>
  <!--  <ng-template let-record pTemplate="listItem">-->
  <!--    <div class="p-col-12">-->
  <!--      <table style="width:350px">-->
  <!--        <tr><td style="width: 300px">{{record.site_name}}</td><td style="width: 50px">-->
  <!--          <p-button [icon]="(clearing[record._id]) ? 'pi pi-spin pi-spinner' : 'pi pi-times-circle'" (click)="clearCache(record._id)"></p-button>-->
  <!--        </td></tr>-->
  <!--        <tr><td colspan="2" style="width: 350px">{{record.instance_id || record.shop_url}}</td></tr>-->
  <!--      </table>-->
  <!--    </div>-->
  <!--  </ng-template>-->
  <ng-template let-record pTemplate="gridItem">
    <div class="p-col-12 p-md-3 p-mb-3">
      <table style="width:350px;border: aqua solid 2px">
        <tr>
          <td style="width: 350px;font-weight: bolder">{{ record.site_name }}</td>
        </tr>
        <tr>
          <td style="width: 350px;">{{ record.instance_id || record.shop_url }}</td>
        </tr>
        <tr>
          <td>
            <!--          <hr style="width: 100%">-->
            <!--          <br/>-->
            <p-button [icon]="(clearing[record._id]) ? 'pi pi-spin pi-spinner' : 'pi pi-times-circle'"
                      styleClass="p-button-sm p-mr-1" (click)="clearCache(record._id)"
                      pTooltip="Clear cache"></p-button>
            <p-button icon="pi pi-search" (click)="selectRecord($event, record)" styleClass="p-button-sm p-mr-1"
                      pTooltip="Show feed details"></p-button>
            <p-button [icon]="(clearing1[record._id]) ? 'pi pi-spin pi-spinner' : 'pi pi-times'"
                      styleClass="p-button-sm p-mr-1 p-button-warning"
                      (click)="cleanAccount(record._id,  'google_platform')"
                      pTooltip="Clear selected Google account"></p-button>
            <p-button [icon]="(clearing2[record._id]) ? 'pi pi-spin pi-spinner' : 'pi pi-times'"
                      styleClass="p-button-sm p-mr-1 p-button-danger"
                      (click)="cleanPlatformCredentials(record._id,'google_platform')"
                      pTooltip="Clear Google credentials"></p-button>
            <p-button *ngIf="selectedProvider==='shopify'"
                      [icon]="(uninstalling[record._id]) ? 'pi pi-spin pi-spinner' : 'pi pi-trash'"
                      styleClass="p-button-sm p-mr-1 p-button-danger" (click)="uninstall_app(record._id)"
                      pTooltip="Uninstall shopify app"></p-button>
            <br>
            <br>
            <p-button *ngIf="selectedProvider==='shopify'" icon="pi pi-verified"
                      styleClass="p-button-sm p-mt-2 p-mr-1 p-button-warning" label="Activate Custom APP"
                      (onClick)="showActivateCustomAppDialog($event, record)"></p-button>
          </td>
        </tr>
      </table>
    </div>
  </ng-template>
</p-dataView>

<p-dialog header="Feed Details" [(visible)]="displayDialog" [minY]="70" [modal]="true"
          [style]="{width: 'auto', height: 'auto'}" (onHide)="onDialogHide()">
  <pre *ngIf="selectedRecord">
    <code style="text-align: left">{{ selectedRecord.feed | json }}</code>
  </pre>
</p-dialog>
<p-dialog header="Activate Custom APP" [(visible)]="displayCustomAppDialog" [minY]="70" [modal]="true"
          [style]="{width: 'auto', height: 'auto'}" (onHide)="onDialogHide()">
  <table style="width: 400px; border-collapse: separate; border-spacing: 30px">
    <tr>
      <td>
          <span class="p-float-label">
            <input id="access-token" type="text" class="p-xl-12" pInputText [(ngModel)]="customAppSettings.access_token">
            <label for="access-token">Access token</label>
          </span>
      </td>
    </tr>
    <tr>
      <td>
        <span class="p-float-label">
          <input id="api-key" type="text" pInputText class="p-xl-12" [(ngModel)]="customAppSettings.api_key">
          <label for="api-key">API Key</label>
        </span>
      </td>
    </tr>
    <tr>
      <td>
          <span class="p-float-label">
            <input id="api-secret" type="text" pInputText  class="p-xl-12" [(ngModel)]="customAppSettings.api_secret">
            <label for="api-secret">API Secret</label>
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span class="p-float-label">
            <p-chips inputId="feedIds" [(ngModel)]="customAppSettings.feedMediaIds" [addOnBlur]="true"
                     [allowDuplicate]="false" [addOnTab]="true"></p-chips>
<!--            <input id="feedId" type="text" pInputText  class="p-xl-12" [(ngModel)]="customAppSettings.feedMediaId">-->
            <label for="feedIds">Feed IDs to enable Custom APP param</label>
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <p-button styleClass="p-button p-button-danger" label="Activate" [disabled]="activatingApp || !selectedRecord || !customAppSettings.access_token || !customAppSettings.api_key || !customAppSettings.api_secret"
                  (onClick)="activateCustomApp()"></p-button>
      </td>
    </tr>
  </table>

</p-dialog>
